import React from 'react';

const TermsConditions = () => (
    <div>
        <h1>Términos y Condiciones</h1>
        <p>
            Al utilizar nuestro sitio web, aceptas estos Términos y Condiciones en su totalidad. Si no estás de acuerdo con estos Términos y Condiciones o cualquier parte de estos Términos y Condiciones, no debes utilizar este sitio web.
        </p>
        {/* Aquí incluirías el resto de tus Términos y Condiciones */}
    </div>
);

export default TermsConditions;